import {ActionTypes} from './user-actions';
import {INITIAL_DASHBOARD_FILTER_PARAMS} from './constants';

export const getInitialState = () => ({
  runningDashboardId: '',
  dashboardLayout: 'grid',
  queryParams: {
    ...INITIAL_DASHBOARD_FILTER_PARAMS,
  },
  showDashboardsFilter: false,
  dashboardFiltersLoaded: false,
  isLightThemeActive: true,
  shortcutAndHotkeysOptions: {},
  dashboardRotation: 0,
  selectedOrganization: null,
  isMobileDevice: false,
  openSolutionsInNewTab: false,
});

const initialState = getInitialState();
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'DESTROY': {
      return getInitialState();
    }
    case ActionTypes.SET_DASHBOARD_LAYOUT: {
      return {
        ...state,
        dashboardLayout: action.layout || initialState.dashboardLayout,
      };
    }
    case ActionTypes.SET_DASHBOARD_LIBRARY_FILTERS: {
      return {
        ...state,
        queryParams: action.filtersData.queryParams,
        showDashboardsFilter: action.filtersData.showDashboardsFilter,
        dashboardFiltersLoaded: true,
      };
    }
    case ActionTypes.RESET_DASHBOARD_LIBRARY_FILTERS: {
      return {
        ...state,
        queryParams: INITIAL_DASHBOARD_FILTER_PARAMS,
        dashboardFiltersLoaded: true,
      };
    }
    case ActionTypes.SET_THEME: {
      return {
        ...state,
        isLightThemeActive: action.isLightThemeActive,
      };
    }
    case ActionTypes.SET_SHORTCUT_AND_HOTKEYS_OPTIONS: {
      return {
        ...state,
        shortcutAndHotkeysOptions: action.shortcutAndHotkeysOptions,
      };
    }
    case ActionTypes.SET_ROTATION: {
      return {
        ...state,
        dashboardRotation: action.dashboardRotation,
      };
    }
    case ActionTypes.HANDLE_ORGANIZATION_CHANGE: {
      return {
        ...state,
        selectedOrganization: action.organization,
        dashboardFiltersLoaded: initialState.dashboardFiltersLoaded,
      };
    }
    case ActionTypes.SET_IS_MOBILE_DEVICE: {
      return {
        ...state,
        isMobileDevice: action.isMobileDevice,
      };
    }
    case ActionTypes.SET_OPEN_SOLUTIONS_IN_NEW_TAB: {
      return {
        ...state,
        openSolutionsInNewTab: action.openSolutionsInNewTab,
      };
    }
    default:
      return state;
  }
};

export default userReducer;
